import { FileAttribute } from '@kaizenplatform/hugot-entity';

import HttpClient from '../../adapter/HttpClient';
import { File as UploadedFile } from '../../graphql/generated/graphql';

export type OnUploadProgress = (ev: ProgressEvent) => void;

class FileUploader {
  private readonly httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public upload = async (file: File, onUploadProgress?: OnUploadProgress): Promise<UploadedFile> => {
    const formData = new FormData();

    formData.append('file', file);

    const config = {
      onUploadProgress: (ev: ProgressEvent) => {
        if (onUploadProgress != null) {
          onUploadProgress(ev);
        }
      },
    };

    const response = await this.httpClient.post('/files', formData, config);

    const res = response.data;
    return {
      id: res.id,
      originalFileName: res.originalFileName,
      url: res.url,
      mimeType: res.mimeType,
      size: res.size,
      fastStart: res.fastStart,
      attribute: FileAttribute.fromJSON(res.attribute),
    };
  };
}

export default FileUploader;
